import React from 'react';
import { hashHistory, Router } from 'react-router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

const AppContainer = ({ store, persistor, routes }) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router history={hashHistory} children={routes} />
    </PersistGate>
  </Provider>
);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js